import React, { useState } from 'react';
import {
  Button,
  Card,
  Field,
  Input,
  MessageBar,
  MessageBarBody,
  Spinner,
  Title2,
  Body1,
} from '@fluentui/react-components';

import { apiClient } from '@/services/api';
import { AuthUser } from '@/types/api';

interface LoginProps {
  onSignedIn: (user: AuthUser) => void;
}

const Login: React.FC<LoginProps> = ({ onSignedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await apiClient.login(email, password));
    } catch (err) {
      const detail = (err as { detail?: string }).detail;
      setError(detail || 'Connexion impossible. Réessayez.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <Card className="login-card">
        <Title2 as="h1">Assistant Alpe d'Huez</Title2>
        <Body1>Connectez-vous avec votre adresse Alpilink.</Body1>

        <form onSubmit={submit} className="login-form">
          <Field label="Adresse e-mail" required>
            <Input
              type="email"
              value={email}
              autoComplete="username"
              onChange={(_, data) => setEmail(data.value)}
              placeholder="prenom.nom@alpilink.ai"
            />
          </Field>

          <Field label="Mot de passe" required>
            <Input
              type="password"
              value={password}
              autoComplete="current-password"
              onChange={(_, data) => setPassword(data.value)}
            />
          </Field>

          {error && (
            <MessageBar intent="error">
              <MessageBarBody>{error}</MessageBarBody>
            </MessageBar>
          )}

          <Button appearance="primary" type="submit" disabled={busy || !email || !password}>
            {busy ? <Spinner size="tiny" /> : 'Se connecter'}
          </Button>
        </form>
      </Card>
    </div>
  );
};

export default Login;
